export default function sleep(timeoutMs) {
    return new Promise((resolve) => {
        setTimeout(resolve, timeoutMs);
    });
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/util/sleep.js